export const GA_MEASUREMENT_ID = process.env.GA_MEASUREMENT_ID || '';

let gaLoaded = false;

export function trackPageview(measurementId = GA_MEASUREMENT_ID) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return;
  }

  try {
    const configData = {
      page_title: document.title,
      page_location: window.location.href,
      page_path: window.location.pathname,
      debug_mode: false,
    };

    window.gtag('config', measurementId, configData);

    window.gtag('event', 'page_view', {
      page_title: document.title,
      page_location: window.location.href,
      page_path: window.location.pathname,
    });
  } catch (error) {
    // no-op
  }
}

export function initGA(measurementId = GA_MEASUREMENT_ID) {
  if (typeof window === 'undefined') return;

  if (gaLoaded) {
    return;
  }

  if (!document.getElementById('ga4-gtag')) {
    const s = document.createElement('script');
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
    s.id = 'ga4-gtag';
    document.head.appendChild(s);
  }

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;

  gtag('js', new Date());
  gtag('config', measurementId, {
    debug_mode: true,
  });

  gaLoaded = true;
}

export function trackGAEvent(eventName, params = {}) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  try {
    window.gtag('event', eventName, params);
  } catch {
    // no-op
  }
}

export function trackFollowUpEvent(eventName, eventLabel) {
  if (typeof window === 'undefined') return;
  if (!window.location.pathname.startsWith('/followup')) return;
  trackGAEvent(eventName, {
    event_category: 'follow_up',
    eventLabel,
  });
}
